<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import PaginationButtons from "@/components/global-themed/PaginationButtons.vue";

const store = useStore();

const pages = computed(() => store.getters["competitionV2/historyPages"]);

const currentPage = computed(() => store.getters['competitionV2/historicPage']);

</script>

<template>
  <PaginationButtons
    :last-page="pages"
    :current-page="currentPage"
    @change="(newPage) => store.dispatch('competitionV2/setHistoricPage', newPage)"
  />
</template>
